import { useRegisterSW } from "virtual:pwa-register/react";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { AnimatePresence, motion } from "framer-motion";
import { Button } from "@archery-inc/design-system";

export default function ReloadPrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();
  const [isLoading, setLoading] = useState(false);

  const close = () => {
    setNeedRefresh(false);
  };

  const reload = async () => {
    setLoading(true);
    await updateServiceWorker(true);
    setNeedRefresh(false);
    setLoading(false);
  };

  return (
    <div>
      <AnimatePresence>
        {needRefresh && (
          <motion.div
            initial={{
              y: "100%",
            }}
            animate={{
              y: 0,
            }}
            transition={{
              type: "spring",
              stiffness: 260,
              damping: 20,
            }}
            className="fixed bottom-2 right-2 rounded-3 p-4 bg-white shadow-y-plus-1"
          >
            <div>
              <FormattedMessage
                id="reload_popup_message"
                defaultMessage="New content available, click on reload button to update."
              />
            </div>
            <div className="flex gap-2 mt-2">
              <Button isDisabled={isLoading} onPress={() => void reload()}>
                <FormattedMessage
                  id="reload_popup_reload"
                  defaultMessage="Reload"
                />
              </Button>
              <Button color="grey" onPress={() => close()}>
                <FormattedMessage
                  id="reload_popup_close"
                  defaultMessage="Close"
                />
              </Button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
